// Translation: Account > Members > Members list > Removal dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		remove: 'Kaldır'
	},
	message: {
		text: 'Bu takım üyesini kaldırmak istediğinize emin misiniz?',
		title: 'Üye kaldırılacak'
	}
})
